<template>
  <a-card :bordered="false">
    是否异常：
    <a-select placeholder="请选择" allowClear style="width:100px;margin-bottom:26px;" @change="$refs.table.refresh();" v-model="isAbnormal">
      <a-select-option :value="1">是</a-select-option>
      <a-select-option :value="2">否</a-select-option>
    </a-select>
    <s-table ref="table" size="default" :columns="columns" :data="loadData">
      <template slot="pic" slot-scope="text">
        <span class="pic"><img :src="text" /></span>
      </template>
      <template slot="type" slot-scope="text, record">
        <p>{{ text }}</p>
        <p>{{ record.stock.sku.specification }}</p>
      </template>
      <template slot="schedule" slot-scope="text">
        {{ (text == "2" || text == "3" || text == "4") ? "是" : "否" }}
      </template>
      <template slot="actual_quantity" slot-scope="text,record">
        {{record.quantity - record.transit_stock + record.excess_inventory}}
      </template> 
      <template slot="schedulenum" slot-scope="text,record">
        <span v-if="record.status == '1'">0</span>
        <span v-else-if="record.status == '2'">-{{ record.transit_stock }}</span>
        <span v-else-if="record.status == '3' || record.status == '4' || record.status == '5'">+{{ record.excess_inventory }}</span>
      </template>
      <template slot="action" slot-scope="text, record">
        <div class="editable-row-operations">
          <!-- <a v-if="!record.status" @click="handle(record,2)">退换</a>
          <a-divider type="vertical" /> -->
          <a v-if="record.status == 3" @click="handle(record, 4)">同意</a>
          <a-divider v-if="record.status == 3" type="vertical" />
          <a v-if="record.status == 3" @click="handle(record, 5)">拒绝</a>
        </div>
      </template>
    </s-table>
  </a-card>
</template>
<script>
import STable from "@/components/table/";
import {
  getAbnormaltail,
  updateAbnormaltail,
  deleteAbnormaltail,
  handleAbnormaltail,
} from "@/api/purchase";

export default {
  name: "Abnormaltail",
  components: {
    STable,
  },
  data() {
    return {
      loading: false,
      isAbnormal:undefined,
      columns: [
        {
          title: "图片",
          dataIndex: "pic_url",
          scopedSlots: { customRender: "pic" },
        },
        {
          title: "名称",
          dataIndex: "goods_name",
        },
        // {
        //   title: '规格',
        //   dataIndex: 'stock.sku.attribute',
        //   scopedSlots: { customRender: 'type' },
        // },
        {
          title: "兑换规则",
          dataIndex: "exchange_price",
        },
        {
          title: "下单数量",
          dataIndex: "quantity",
        },
        {
          title: "单价",
          dataIndex: "unit_price",
        },
        {
          title: "在途数量",
          dataIndex: "transit_stock",
        },
        {
          title: "到货数量",
          dataIndex: 'actual_quantity',
          scopedSlots: { customRender: 'actual_quantity' },
        },
        {
          title: "是否异常",
          dataIndex: "status",
          scopedSlots: { customRender: "schedule" },
        },
        {
          title: "异常数",
          dataIndex: "status",
          scopedSlots: { customRender: "schedulenum" },
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
        },
      ],
      loadData: (params) => {
        if(this.isAbnormal){
          params.is_abnormal = this.isAbnormal
        }
        return getAbnormaltail(
          Object.assign(params, { id: this.$route.params.id })
        ).then((res) => res);
      },
    };
  },
  methods: {
    handle(row, status) {
      const params = {
        id: row.id,
        status,
      };
      handleAbnormaltail(params).then((res) => {
        this.$message.success("操作成功");
        this.$refs.table.refresh();
      });
    },
  },
};
</script>
<style scoped>
.pic {
  width: 50px;
  height: 50px;
}
.pic > img {
  width: 50px;
  height: 50px;
  display: block;
}
</style>

